'use client';

import { HeaderCart } from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import { useGetCartDetailsQuery } from 'services/cart/use-query-get-cart-details';
import { useCoreContext } from 'providers/core-provider';
import { useEsiteCtx } from 'services/esite/context';
import { useEffect } from 'react';
import { CartResponse } from 'services/cart/types';

export const CartClient = ({
  cartItems,
  href
}: {
  cartItems: number;
  href?: string;
}) => {
  const t = useTranslations();
  const { locale, storeId } = useEsiteCtx();
  const title = t('ENCLOSED_SHOPPING_INFO');
  const { cartLastUpdated, isAddingToCartPending } = useCoreContext();
  const { data, refetch, isRefetching } = useGetCartDetailsQuery({
    storeId,
    locale
  });
  const getNumberOfItemsInOrder = (orderDetails: CartResponse) => {
    return orderDetails?.orderItems?.reduce(
      (total, item) => total + item.quantity,
      0
    );
  };

  useEffect(() => {
    if (!isAddingToCartPending) {
      refetch();
    }
    // cartLastUpdate is used to trigger the refetching. Do not delete
  }, [cartLastUpdated, isAddingToCartPending, refetch]);

  const items = data ? getNumberOfItemsInOrder(data) : cartItems;
  return (
    <HeaderCart
      cartItems={isRefetching ? '...' : items}
      id={'headerCart'}
      title={title}
      redirectionLink={href}
    />
  );
};
